import { Component, OnInit, OnDestroy } from '@angular/core';
import { CurrencyPipe } from '@angular/common';


@Component({
    selector: 'app-invoice-upd',
    templateUrl: './invoice-upd.component.html',
    styleUrls: ['./invoice-upd.component.scss'],
    providers: [CurrencyPipe]
})

export class InvoiceUpdComponent implements OnInit, OnDestroy {
   

    constructor(
    ) {



    }
    ngOnDestroy(): void {
        
    }

    ngOnInit(): void {};
    

}
